import { Tooltip } from 'antd'
import React from 'react'

const OfferIssuedIcon = () => {
  return (
    <Tooltip title="Offer Declined">
      <svg
        width="21"
        height="21"
        viewBox="0 0 21 21"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.5 0C4.70156 0 0 4.70156 0 10.5C0 16.2984 4.70156 21 10.5 21C16.2984 21 21 16.2984 21 10.5C21 4.70156 16.2984 0 10.5 0ZM10.5 19.2188C5.68594 19.2188 1.78125 15.3141 1.78125 10.5C1.78125 5.68594 5.68594 1.78125 10.5 1.78125C15.3141 1.78125 19.2188 5.68594 19.2188 10.5C19.2188 15.3141 15.3141 19.2188 10.5 19.2188Z"
          fill="#E35E50"
        />
        <path
          d="M4.875 8.25625L10.5 13.8813L14.875 9.50625V12.375H16.125V7.375H11.125V8.625H13.9937L10.5 12.1188L5.75625 7.375L4.875 8.25625Z"
          fill="#E35E50"
        />
      </svg>
    </Tooltip>
  )
}

export default OfferIssuedIcon
